"use client";
import React from "react";
import Styles from "./LeadForm.module.scss";
import CustomPhoneInput from "@/sdk/CustomPhoneInput";
import CustomNameField from "@/sdk/CustomeNameField";
import CustomButton from "@/sdk/CustomButton/CustomButton";
import CustomSelect from "@/sdk/CustomSelect/CustomSelect";
import useLeadForm from "@/hooks/leadform";
import { CITIES_DATA } from "@/constants/cities";
const LeadForm = ({ heading, showButtons, showPopupHeading, marginBottom, formName }) => {
    const { form, loading } = useLeadForm({ formName:formName });
    return (
        <div className={Styles.formContainer} style={{ marginBottom: marginBottom }}>
            <div className={Styles.formHeading}>
                <h2>{heading}</h2>
            </div>
            {
                showPopupHeading && (<div className={Styles.popupFormHeading}>
                    <h2>Please fill the form</h2>
                    <div className={Styles.formSubHeading}>
                        Our team will call you back in 24 hours!
                    </div>
                </div>)
            }
            <div className={Styles.formContent}>
                <CustomNameField label={"Name"}
                    field={form.getFieldProps('name')}
                />
                <CustomPhoneInput
                    form={form}
                    field={form.getFieldProps('mobile')}
                    label={"Mobile Number"} />
                <div>
                    <div className={Styles.consentBox}>

                        <input type="checkbox" name="consent" value={form?.values?.consent} onChange={form.handleChange} />
                        <div>
                            {/* <label>I authorise Innovolt & its representatives to contact me with updates and notifications via SMS/WhatsApp/Call/RCS. This consent overrides any registration for DNC / NDNC.</label> */}
                            <label>I agree to the <a href="/terms-and-conditions" target="_blank">terms & conditions</a>, <a href="/privacy-policy" target="_blank">privacy policy</a> below and give my consent to receive calls, RCS and (WhatsApp) messages to provide further information.</label>
                        </div>
                    </div>
                    {form?.errors['consent'] && <div className={Styles.errorText}> * Please check the consent box to proceed </div>}
                </div>

                <div className={Styles.selectWrapper}>
                    <CustomSelect
                        form={form}
                        field={form.getFieldProps('city')}
                        label={"Select City"}
                        options={CITIES_DATA}
                        placeholder={"Select City"}
                        sx={{
                            container: (baseStyles) => ({
                                ...baseStyles,
                                height: "36px",
                            }),
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderRadius: "4px",
                                border: "1px solid #7D7D7D",
                                boxShadow: "none",
                                fontSize: "16px",
                                fontFamily: "Inter",
                                fontWeight: "500",
                            }),
                            option: (baseStyles, { isFocused, isSelected }) => ({
                                ...baseStyles,
                                fontFamily: "Inter",
                                fontSize: "12px",
                            }),
                        }}
                    />
                    <CustomButton
                        type={"submit"}
                        label={"Contact Us"}
                        sx={{
                            height: "36px",
                            backgroundColor: "#2378F3",
                            color: "#fff",
                            borderRadius: "4px",
                            marginTop: "8px",
                        }}
                        handleClick={(e) => {
                            form.setFieldValue('buttonText',e.target.innerText);
                            form.setFieldValue('buttonType', 'lead');
                            form.handleSubmit(e);
                        }}
                    />
                </div>
                {
                    showButtons && (
                        <div className={Styles.contactUsButtons}>
                            {form?.errors['mobile'] && <div className={Styles.errorText}> * Please enter your mobile number to proceed </div>}
                            <CustomButton
                                label={"WhatsApp us"}
                                sx={{
                                    height: "36px",
                                    backgroundColor: "#FFF",
                                    color: "#000",
                                    fontSize: "16px",
                                    borderRadius: "4px",
                                    fontFamily: "Inter",
                                }}
                                handleClick={(e) => {
                                    form.setFieldValue('buttonText',e.target.innerText);
                                    form.setFieldValue('buttonType', 'whatsapp');
                                    form.handleSubmit();
                                }}
                                disabled={loading}
                                icon={"https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-us-icon.svg"}
                            />
                            <CustomButton
                                label={"Call us now"}
                                sx={{
                                    height: "36px",
                                    backgroundColor: "#FFF",
                                    color: "#000",
                                    borderRadius: "4px",
                                    fontSize: "16px",
                                    fontFamily: "Inter",
                                }}
                                handleClick={(e) => {
                                    form.setFieldValue('buttonText',e.target.innerText);
                                    form.setFieldValue('buttonType', 'call');
                                    form.handleSubmit();
                                }}
                                icon={"https://assets.turnoclub.com/developer/innovolt/icons/call-us-icon.svg"}
                                disabled={loading}
                            />
                        </div>
                    )
                }

            </div>

        </div>
    );
};
export default LeadForm;
